export type IApiFileUploadRequestBody = {
  /**
   * The file name
   */
  name: string;

  /**
   * The file MIME type
   */
  type: string;

  /**
   * The file size in bytes
   */
  size: number;
};

export type IApiFilesUploadRequestBody = {
  files: Array<IApiFileUploadRequestBody>;
  metadata?: {
    opts?: string;
  } & Record<string, string>;
};

export type IApiFileUploadResponseBody = {
  /**
   * The file ID
   */
  id: string;

  /**
   * The file name
   */
  name: string;

  /**
   * The URL to upload the file with a PUT request
   */
  url: string;
};

export type IApiFilesUploadResponseBody = Array<IApiFileUploadResponseBody>;

export type IApiFileUploadProgressEvent = {
  loading: boolean;
  progress?: number;
};

export enum IApiFileUploadStatus {
  // server statuses
  UPLOADING = 0,
  UPLOAD_ERROR = 5,
  ENCODING = 10,
  ENCODING_JOB_ERROR = 12,
  ENCODING_ERROR = 15,
  READY = 20,

  // dashboard specific statuses
  PREPARING_FILE = 40,
  ERROR = 50,
}

export type IApiAbstractFile = {
  status?: IApiFileUploadStatus;
};
